import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-user-notifications',
  templateUrl: './user-notifications.component.html',
  styleUrls: ['./user-notifications.component.css']
})
export class UserNotificationsComponent implements OnInit {

	showNotifications: boolean;

	constructor() {}

	ngOnInit() {
		this.showNotifications = false;
	}

	

}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/components/user-notifications/user-notifications.component.ts